export default __webpack_public_path__ + "static/media/casaley.003409d0.png";